import { useState } from "react";
import { DrawPad } from "./DrawPad";

// ─── Signing an agreement for the business, after the customer has signed ────
// onSign({ name, title, typedName, signatureImage, consent }) → { error? }
export function BusinessSignModal({ request, businessName, onSign, onClose }) {
  const [form, setForm] = useState({ name: "", title: "", typedName: "" });
  const [typedTouched, setTypedTouched] = useState(false);
  const [drawn, setDrawn] = useState(null);
  const [consent, setConsent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const typed = typedTouched ? form.typedName : form.name;   // the typed signature follows the name until changed
  const ready = form.name.trim().length > 1 && typed.trim().length > 1 && consent;

  async function submit(e) {
    e.preventDefault();
    setBusy(true); setError("");
    const d = await onSign({ name: form.name.trim(), title: form.title.trim(), typedName: typed.trim(), signatureImage: drawn, consent });
    setBusy(false);
    if (d?.error) setError(d.error);
  }

  return (
    <div className="modal-ov" onClick={e => e.target === e.currentTarget && !busy && onClose()}>
      <div className="modal" role="dialog" aria-modal="true" style={{ width: 560 }}>
        <div className="mh"><div className="mt">Sign for {businessName || "the business"}</div><button className="mc" onClick={onClose} disabled={busy}>✕</button></div>
        <form onSubmit={submit}>
          <div className="mb-m">
            <p className="tsub tsm" style={{ marginBottom: 12 }}>
              <strong>{request.signer_name}</strong> signed <strong>{request.title}</strong>. Once you sign for {businessName || "the business"}, the final PDF
              with both signatures and the signing certificate is saved to the unit's Documents and emailed to {request.signer_name} and you.
            </p>
            {error && <div className="login-err">{error}</div>}
            <div className="fg">
              <div className="fgi"><label>Your full name</label><input value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} autoFocus autoComplete="name" /></div>
              <div className="fgi"><label>Job title (optional)</label><input value={form.title} onChange={e => setForm(f => ({ ...f, title: e.target.value }))} placeholder="e.g. Director" /></div>
              <div className="fgi full"><label>Type your name to sign</label>
                <input value={typed} onChange={e => { setTypedTouched(true); setForm(f => ({ ...f, typedName: e.target.value })); }} /></div>
            </div>
            {typed.trim().length > 1 && <div style={{ fontFamily: "Georgia, serif", fontStyle: "italic", fontSize: 26, color: "var(--navy)", margin: "6px 0 10px" }}>{typed}</div>}
            <div className="fgi"><label>Draw your signature (optional)</label><DrawPad onChange={setDrawn} /></div>
            <label style={{ display: "flex", gap: 10, alignItems: "flex-start", fontSize: 13, marginTop: 12, padding: "10px 12px", cursor: "pointer", borderRadius: 9,
              background: consent ? "#EBF5F0" : "#FFF8E6", border: `2px solid ${consent ? "var(--success)" : "#E8B931"}` }}>
              <input type="checkbox" style={{ width: 22, height: 22, minWidth: 22, margin: 0 }} checked={consent} onChange={e => setConsent(e.target.checked)} />
              <span>I'm authorised to sign this agreement for {businessName || "the business"}, and I agree to sign it electronically.</span>
            </label>
          </div>
          <div className="mf">
            <button type="button" className="btn btn-outline" onClick={onClose} disabled={busy}>Cancel</button>
            <button className="btn btn-primary" disabled={busy || !ready}>{busy ? "Signing…" : "Sign for the business"}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
